export const AssetList = [
  'face_shape_female_extra_heart',
  'face_shape_female_heart',
  'face_shape_female_average',
  'face_shape_female_rect',
  'face_shape_female_extra_rect',

  'face_shape_male_extra_heart',
  'face_shape_male_heart',
  'face_shape_male_average',
  'face_shape_male_rect',
  'face_shape_male_extra_rect',

  'ears_female',
  'ears_male',

  'neck_female',
  'neck_male',

  'hair_female_style1_front',
  'hair_female_style1_back',
  'hair_female_style2_front',
  'hair_female_style2_back',

  'hair_male_style1_front',
  'hair_male_style1_back',
  'hair_male_style2_front',
  'hair_male_style2_back',
  
  'facial_hair_full_beard_thick',

  'facial_hair_full_beard_thin_extra_heart',
  'facial_hair_full_beard_thin_heart',
  'facial_hair_full_beard_thin_average',
  'facial_hair_full_beard_thin_rect',
  'facial_hair_full_beard_thin_extra_rect',

  'facial_hair_mustache_thick',
  'facial_hair_mustache_thin',
  'facial_hair_chin_mustache_thick_extra_heart',
  'facial_hair_chin_mustache_thin_extra_heart',
  'facial_hair_chin_mustache_thick_heart',
  'facial_hair_chin_mustache_thin_heart',
  'facial_hair_chin_mustache_thick_average',
  'facial_hair_chin_mustache_thin_average',
  'facial_hair_chin_mustache_thick_rect',
  'facial_hair_chin_mustache_thin_rect',
  'facial_hair_chin_mustache_thick_extra_rect',
  'facial_hair_chin_mustache_thin_extra_rect',

  'hat_female_beanie',
  'hat_male_beanie',

  'glasses_male_square',
  'glasses_female_square',

  'eyes_female_extra_round',
  'eyes_female_extra_round_makeup',
  'eyes_male_extra_round',

  'eyes_female_round',
  'eyes_female_round_makeup',
  'eyes_male_round',

  'eyes_female_average',
  'eyes_female_average_makeup',
  'eyes_male_average',

  'eyes_female_thin',
  'eyes_female_thin_makeup',
  'eyes_male_thin',

  'eyes_female_extra_thin',
  'eyes_female_extra_thin_makeup',
  'eyes_male_extra_thin',

  'eyebrow_female_arched_thick',
  'eyebrow_male_arched_thick',
  'eyebrow_female_straight_thick',
  'eyebrow_male_straight_thick',

  'eyebrow_female_arched_average',
  'eyebrow_male_arched_average',
  'eyebrow_female_straight_average',
  'eyebrow_male_straight_average',

  'eyebrow_female_arched_thin',
  'eyebrow_male_arched_thin',
  'eyebrow_female_straight_thin',
  'eyebrow_male_straight_thin',

  'cheeks_female_high',
  'cheeks_male_high',

  'nose_female_wide',
  'nose_female_average',
  'nose_female_narrow',

  'nose_male_wide',
  'nose_male_average',
  'nose_male_narrow',

  'mouth_female_thick',
  'mouth_female_average',
  'mouth_female_thin',

  'mouth_male_thick',
  'mouth_male_average',
  'mouth_male_thin'
  ]

export const AssetListMasks = [
  'face_shape_female_extra_heart_mask',
  'face_shape_female_heart_mask',
  'face_shape_female_average_mask',
  'face_shape_female_rect_mask',
  'face_shape_female_extra_rect_mask',

  'face_shape_male_extra_heart_mask',
  'face_shape_male_heart_mask',
  'face_shape_male_average_mask',
  'face_shape_male_rect_mask',
  'face_shape_male_extra_rect_mask',

  'ears_female_mask',
  'ears_male_mask',

  'neck_female_mask',
  'neck_male_mask',

  'hair_female_style1_front_mask',
  'hair_female_style1_back_mask',
  'hair_female_style2_front_mask',
  'hair_female_style2_back_mask',

  'hair_male_style1_front_mask',
  'hair_male_style1_back_mask',
  'hair_male_style2_front_mask',
  'hair_male_style2_back_mask',
  

  'shadow_extra_heart_mask',
  'shadow_heart_mask',
  'shadow_average_mask',
  'shadow_rect_mask',
  'shadow_extra_rect_mask',

  'facial_hair_full_beard_thick_mask',

  'facial_hair_full_beard_thin_extra_heart_mask',
  'facial_hair_full_beard_thin_heart_mask',
  'facial_hair_full_beard_thin_average_mask',
  'facial_hair_full_beard_thin_rect_mask',
  'facial_hair_full_beard_thin_extra_rect_mask',

  'facial_hair_mustache_thick_mask',
  'facial_hair_mustache_thin_mask',
  
  'facial_hair_chin_mustache_thick_extra_heart_mask',
  'facial_hair_chin_mustache_thin_extra_heart_mask',
  'facial_hair_chin_mustache_thick_heart_mask',
  'facial_hair_chin_mustache_thin_heart_mask',
  'facial_hair_chin_mustache_thick_average_mask',
  'facial_hair_chin_mustache_thin_average_mask',
  'facial_hair_chin_mustache_thick_rect_mask',
  'facial_hair_chin_mustache_thin_rect_mask',
  'facial_hair_chin_mustache_thick_extra_rect_mask',
  'facial_hair_chin_mustache_thin_extra_rect_mask',

  'hat_female_beanie_mask',
  'hat_male_beanie_mask',

  'glasses_male_square_mask',
  'glasses_female_square_mask',

  'eyes_female_extra_round_mask',

  'eyes_male_extra_round_mask',

  'eyes_female_round_mask',

  'eyes_male_round_mask',

  'eyes_female_average_mask',

  'eyes_male_average_mask',

  'eyes_female_thin_mask',

  'eyes_male_thin_mask',

  'eyes_female_extra_thin_mask',

  'eyes_male_extra_thin_mask',

  'eyebrow_female_arched_thick_mask',
  'eyebrow_male_arched_thick_mask',
  'eyebrow_female_straight_thick_mask',
  'eyebrow_male_straight_thick_mask',

  'eyebrow_female_arched_average_mask',
  'eyebrow_male_arched_average_mask',
  'eyebrow_female_straight_average_mask',
  'eyebrow_male_straight_average_mask',

  'eyebrow_female_arched_thin_mask',
  'eyebrow_male_arched_thin_mask',
  'eyebrow_female_straight_thin_mask',
  'eyebrow_male_straight_thin_mask',
  

  'mouth_female_thick_mask',
  'mouth_female_average_mask',
  'mouth_female_thin_mask',

  'mouth_male_thick_mask',
  'mouth_male_average_mask',
  'mouth_male_thin_mask'
]